'use client'

import { Box, Grid, Heading, Text } from '@chakra-ui/react'
import { ContentContainer } from 'ui'
import { FC } from 'react'
import { SectionLabel, SectionTitle } from '../_components/granditude'

export const ThinkingSection: FC = () => {
  return (
    <Box as="section" w="100%" py={{ base: 16, md: 32 }} bg="background.surface">
      <ContentContainer>
        <Grid
          templateColumns={{ base: '1fr', lg: '1fr 1.2fr' }}
          gap={{ base: 10, lg: 16 }}
          alignItems="start"
        >
          <Box>
            <SectionLabel>How We Think</SectionLabel>
            <SectionTitle>We solve differently</SectionTitle>
            <Text fontSize="1.1rem" color="text.secondary" mb={6} lineHeight={1.7}>
              Most companies try to sell you a product. We start by understanding what&apos;s
              actually broken — then we figure out how to fix it.
            </Text>
            <Text fontSize="1.1rem" color="text.secondary" lineHeight={1.7}>
              Sometimes that means using our existing tools. Sometimes it means building something
              new. Sometimes it means connecting what you already have.
            </Text>
          </Box>

          <Box
            bg="background.default"
            border="1px solid"
            borderColor="border.default"
            borderRadius="card"
            p={{ base: 6, md: 10 }}
          >
            <Text
              fontSize="0.75rem"
              fontWeight={600}
              letterSpacing="0.1em"
              textTransform="uppercase"
              color="teal.500"
              mb={4}
            >
              Example
            </Text>
            <Heading as="h4" fontFamily="display" fontSize="1.3rem" fontWeight={500} mb={6}>
              Inventory never matches
            </Heading>
            <Text fontSize="0.95rem" color="text.secondary" mb={4} lineHeight={1.7}>
              Most companies try to fix this with another plugin or integration. That usually makes
              it worse — now you have one more system to debug.
            </Text>
            <Text fontSize="0.95rem" lineHeight={1.7} mb={4}>
              <Text as="strong" color="text.default">
                We&apos;d start by mapping where data actually flows.
              </Text>{' '}
              Then we&apos;d find the single source of truth (or create one). Then we&apos;d build a
              sync that actually works — tested, monitored, reliable.
            </Text>
            <Text fontSize="0.95rem" color="text.secondary" lineHeight={1.7}>
              Sound obvious? It is. But almost no one does it.
            </Text>
          </Box>
        </Grid>
      </ContentContainer>
    </Box>
  )
}
